<template>
	<div element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" class="flip_box">
		<img class="bj_img" src="../../assets/jubj.svg" alt="" />
		<div class="page-box">
			<!-- :style="{
					backgroundImage: 'url(' + require('@/assets/bookBackg.jpg') + ')',
				}" -->
			<div class="book_div">
				<div class="flip-book" id="demoBookExample">
					<!-- <div class="page page-cover page-cover-top" data-density="hard">
					<div class="page-content">
						<h2>BOOK TITLE</h2>
					</div>
				</div> -->
					<div class="page" v-for="(e, i) in filePage" :key="i">
						<div class="page-content">
							<div class="canvas-loading">
								<el-icon class="loading-icon" size="30px"><Loading /></el-icon>
							</div>
							<canvas :id="'pageNum-' + (Number(i) + 1)"></canvas>
							<!-- <div class="page-footer">{{ e }}</div> -->
						</div>
					</div>
					<!-- PAGES .... -->
					<!-- <div
					class="page page-cover page-cover-bottom"
					data-density="hard"
				>
					<div class="page-content">
						<h2>THE END</h2>
					</div>
				</div> -->
				</div>
			</div>
			<div class="btn-box" v-show="is_show_btn">
				<div v-if="store_id == 385" :style="is_mobile ? 'position: absolute;top:6px; left: 0;display: flex;' : ''" class="info-box">
					<p class="p1">获取完整刊物请联系郑老师</p>
					<p class="p2">电话/微信:19980570961</p>
				</div>
				<div class="button-box">
					<div>
						<span @click="btn_prev">上一页</span>
						<div style="padding: 0 20px">
							<span> {{ current }} </span> / <span> {{ pageTotal }} </span>
						</div>
						<span @click="btn_next">下一页</span>
					</div>
					<div v-show="check_root.download_type != 4" @click="download_btn" style="cursor: pointer">下载</div>
				</div>
				<div v-if="store_id == 385 && !is_mobile" style="width: 144px"></div>
			</div>
		</div>
		<el-dialog
			v-model="permissiondialogVisible"
			title=""
			top="20vh"
			width="500px"
			custom-class="dialog_class"
			:before-close="
				() => {
					permissiondialogVisible = false;
				}
			"
		>
			<div v-if="common_init" class="permission_dialog_box">
				<img class="info_img" src="../../assets/info.svg" alt="" />
				<p class="permission_p">{{ log_msg }}</p>
				<div class="permission_div1">
					<img src="../../assets/phone.svg" alt="" />
					<span>{{ common_init.config.info.phone }}（ {{ common_init.config.info.user_name }} ）</span>
				</div>
				<div class="permission_div2">
					<el-button @click="permissiondialogVisible = false">我知道了</el-button>
					<!-- <el-button type="primary">立即入会</el-button> -->
				</div>
			</div>
		</el-dialog>
		<el-dialog
			v-model="logindialogVisible"
			title=""
			top="20vh"
			width="500px"
			custom-class="dialog_class"
			:close-on-click-modal="journal_data ? true : false"
			:close-on-press-escape="journal_data ? true : false"
			:show-close="journal_data ? true : false"
			:before-close="
				() => {
					logindialogVisible = false;
				}
			"
		>
			<div v-if="common_init" class="permission_dialog_box">
				<img class="info_img" src="../../assets/info.svg" alt="" />
				<p class="permission_p">{{ log_msg }}</p>
				<!-- <div class="permission_div1">
					<img src="../../assets/phone.svg" alt="" />
					<span>{{ common_init.config.info.phone }}（ {{ common_init.config.info.user_name }} ）</span>
				</div> -->
				<div class="permission_div2">
					<el-button v-if="journal_data" @click="logindialogVisible = false">我知道了</el-button>
					<el-button @click="login_immediately" type="primary">立即登录</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			v-model="hintVisible"
			title=""
			top="20vh"
			custom-class="dialog_class"
			width="500px"
			:before-close="
				() => {
					hintVisible = false;
				}
			"
		>
			<div class="permission_dialog_box">
				<img class="info_img" src="../../assets/info.svg" alt="" />
				<p class="permission_p">请在外部浏览器中打开下载！</p>
			</div>
		</el-dialog>
	</div>
</template>
<script>
let t;
import { pathToBase64, base64ToPath } from '@/utils/image-tools';
import PDFJS from 'pdfjs-dist';
import { PageFlip } from 'page-flip';
// 如果你没加这两行，解析 PDF 时网页会完全卡死
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export default {
	data() {
		return {
			hintVisible: false,
			pageFlipObj: '',
			pageFlipBoxWidth: 800,
			pageFlipBoxHeight: 800,
			current: 1,
			pageTotal: 1,
			arrayBuffer: null, // arrayBuffer
			pdfPath: '',
			filePage: 0,
			journal_data: '',
			journal_id: '',
			check_root: '',
			common_init: '',
			user_record_type: '',
			permissiondialogVisible: false,
			logindialogVisible: false,
			log_msg: '需要登录后才能查看！',
			is_show_btn: false,
			fullscreenLoading: true,
			label: '',
			store_id: '',
			is_mobile: false,
			pageDimensions: [],
			hasLandscapePage: false,
			hasLandscapePageData: null,
		};
	},
	created() {
		if (localStorage.is_pc == 0) {
			console.log('手机端');
			this.is_mobile = true;
		} else {
			console.log('PC端');
		}
		// document.title = '电子期刊';
		this.journal_id = this.$route.query.id;
		this.journal_label = this.$route.query.label;
		if (this.$route.query.store_id) {
			this.store_id = this.$route.query.store_id;
		}
	},
	mounted() {
		t = this;
		this.get_journal_check_root();
		this.get_journal_data();
		this.get_common_init();
		if (localStorage.token) {
			this.get_user_record();
		}
	},
	methods: {
		// === 保留原有业务逻辑 ===
		login_immediately() {
			if (window.parent) {
				window.parent.postMessage({ cmd: 'login', params: { status: '0' } }, '*');
			}
		},
		download_btn() {
			if (localStorage.is_pc == 0 && localStorage.is_weixin == 1) {
				this.hintVisible = true;
			} else {
				if (this.check_root.download_type == 1) {
					this.handleDown({ url: this.journal_data.file, fileName: this.journal_data.title + '.pdf' });
				} else if (this.check_root.download_type == 2) {
					if (localStorage.token) {
						this.handleDown({ url: this.journal_data.file, fileName: this.journal_data.title + '.pdf' });
					} else {
						this.log_msg = '需要登录后才能下载！';
						this.logindialogVisible = true;
					}
				} else if (this.check_root.download_type == 3) {
					if (localStorage.token) {
						if (this.user_record_type) {
							this.handleDown({ url: this.journal_data.file, fileName: this.journal_data.title + '.pdf' });
						} else {
							this.log_msg = '非常抱歉，该账号没有权限下载，如有需求请联系我们';
							this.permissiondialogVisible = true;
						}
					} else {
						this.log_msg = '需要登录后才能下载！';
						this.logindialogVisible = true;
					}
				}
			}
		},
		async get_journal_check_root() {
			const res = await this.$request('/api/pc/file/check_root', { label: this.journal_label }, 'get');
			this.check_root = res.data;
		},
		async get_journal_data() {
			const res = await this.$request('/api/pc/file/info', { id: this.journal_id, label: this.journal_label }, 'get');
			if (res.code == 1) {
				this.journal_data = res.data;
				function containsIgnoreCase(str, char) {
					const regex = new RegExp(char, 'i');
					return regex.test(str);
				}
				if (this.is_mobile && containsIgnoreCase(this.journal_data.file, '.pdf')) {
					window.location.href = `https://h5.xiebanyun.com/#/pagesB/h5-show-pdf/index?file=${this.journal_data.file}`;
				}
				this.pathToBase64Api(this.journal_data.file);
			} else {
				if (localStorage.token) {
					this.log_msg = '非常抱歉，该账号没有权限查看，如有需求请联系我们';
					this.permissiondialogVisible = true;
				} else {
					this.log_msg = '需要登录后才能查看！';
					this.logindialogVisible = true;
				}
			}
		},
		async get_common_init() {
			const res = await this.$request('/api/common/init', {}, 'get');
			this.common_init = res.data;
		},
		async get_user_record() {
			try {
				const res = await this.$request('/api/pc/user/record', {}, 'get');
				if (res.code != 0) {
					this.user_record_type = res.data.type;
				}
			} catch (error) {}
		},
		btn_prev() {
			this.pageFlipObj.flipPrev();
		},
		btn_next() {
			this.pageFlipObj.flipNext();
		},

		// === 核心优化后的 PDF 渲染逻辑 ===

		async pathToBase64Api(pdfPath) {
			try {
				const response = await fetch(pdfPath);
				const arrayBuffer = await response.arrayBuffer();
				this.arrayBuffer = arrayBuffer;
				this.createCanvas(arrayBuffer);
			} catch (error) {
				console.error('加载文件失败，使用降级方案', error);
				pathToBase64(pdfPath).then((base64) => {
					let file = this.dataURLtoFile(base64, 'pdf文件');
					let fileReader = new FileReader();
					fileReader.readAsArrayBuffer(file);
					fileReader.onload = (e) => {
						this.arrayBuffer = e.target.result;
						this.createCanvas(this.arrayBuffer);
					};
				});
			}
		},

		async createCanvas(val) {
			const loadingTask = PDFJS.getDocument({
				data: val,
				// 启用 cMap 以防某些字体乱码
				cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.2.228/cmaps/',
				cMapPacked: true,
			});
			const pdf = await loadingTask.promise;

			this.filePage = pdf.numPages;
			this.pageTotal = pdf.numPages;

			this.pageDimensions = []; // 初始化数组
			// 【新增】获取每一页的原始尺寸 (scale: 1)
			for (let i = 1; i <= pdf.numPages; i++) {
				const page = await pdf.getPage(i);
				const viewport = page.getViewport({ scale: 1 });
				this.pageDimensions.push({
					pageNumber: i,
					width: viewport.width,
					height: viewport.height,
				});
			}
			this.hasLandscapePage = this.pageDimensions.some((page) => page.width > page.height);
			this.hasLandscapePageData = this.hasLandscapePage
				? {
						pageNumber: 'max',
						width: Math.max(...this.pageDimensions.map((page) => page.width)),
						height: Math.max(...this.pageDimensions.map((page) => page.height)),
				  }
				: this.pageDimensions[0] || null;

			// console.log('所有页面尺寸:', this.pageDimensions);

			if (this.filePage == 2 && !this.is_mobile && !this.hasLandscapePage) {
				this.current = 2;
			}

			this.applyBookFitSize();

			await this.$nextTick();

			// 【解决启动卡顿】1. 先只渲染前 2 页（封面和第一页）
			const priorityPages = Math.min(2, this.filePage);
			for (let i = 1; i <= priorityPages; i++) {
				await this.renderPageTask(pdf, i);
			}

			// 【解决启动卡顿】2. 立即初始化书本，让 Loading 消失，用户可以先看封面
			this.initBookLayout();

			// 【解决启动卡顿】3. 延迟 1 秒后，在浏览器空闲时静默渲染后续页面
			setTimeout(() => {
				this.renderRemainingPages(pdf, priorityPages + 1);
			}, 1000);
		},

		async renderPageTask(pdf, pageNumber) {
			const page = await pdf.getPage(pageNumber);

			const canvas = document.getElementById(`pageNum-${pageNumber}`);
			if (!canvas) return;

			const context = canvas.getContext('2d', { alpha: false });

			const pageSize = this.pageDimensions[pageNumber - 1] || this.hasLandscapePageData || this.pageDimensions[0];
			const fillPage = this.hasLandscapePage;
			const canvasBaseSize = fillPage ? this.hasLandscapePageData || pageSize : pageSize;
			const displayScale = fillPage
				? Math.min(this.pageFlipBoxWidth / canvasBaseSize.width, this.pageFlipBoxHeight / canvasBaseSize.height)
				: Math.min(this.pageFlipBoxWidth / pageSize.width, this.pageFlipBoxHeight / pageSize.height);
			const cssWidth = pageSize.width * displayScale;
			const cssHeight = pageSize.height * displayScale;
			const outputScale = Math.min((window.devicePixelRatio || 1) * (this.is_mobile ? 2.5 : 2), this.is_mobile ? 5 : 6);

			const viewport = page.getViewport({ scale: displayScale * outputScale });
			const canvasCssWidth = Math.max(Math.round(fillPage ? this.pageFlipBoxWidth : cssWidth), 1);
			const canvasCssHeight = Math.max(Math.round(fillPage ? this.pageFlipBoxHeight : cssHeight), 1);

			// 存储 CSS 逻辑大小，用于初始化 PageFlip
			if (!this.viewport_size) {
				this.viewport_size = page.getViewport({ scale: 1 });
			}

			// 设置 Canvas 绘图表面积（物理像素）
			canvas.width = fillPage ? Math.round(canvasCssWidth * outputScale) : Math.round(viewport.width);
			canvas.height = fillPage ? Math.round(canvasCssHeight * outputScale) : Math.round(viewport.height);
			context.fillStyle = '#ffffff';
			context.fillRect(0, 0, canvas.width, canvas.height);

			// 设置 Canvas 页面显示面积（CSS 像素）
			canvas.style.width = `${canvasCssWidth}px`;
			canvas.style.height = `${canvasCssHeight}px`;
			canvas.style.display = 'block';
			canvas.style.margin = '0';

			const renderContext = {
				canvasContext: context,
				viewport: viewport,
				intent: fillPage ? 'print' : 'display', // 铺满时优先清晰度
			};
			if (fillPage) {
				renderContext.transform = [1, 0, 0, 1, Math.round(Math.max((canvas.width - viewport.width) / 2, 0)), Math.round(Math.max((canvas.height - viewport.height) / 2, 0))];
			}

			await page.render(renderContext).promise;
			page.cleanup(); // 渲染完立即释放页面资源，防止内存溢出
		},

		async renderRemainingPages(pdf, startPage) {
			for (let i = startPage; i <= this.filePage; i++) {
				// 每页渲染间隙增加到 300ms，确保不会影响到用户的翻页操作
				await new Promise((resolve) => setTimeout(resolve, 300));
				await this.renderPageTask(pdf, i);
			}
		},

		getBookFitSize() {
			const basePage = this.hasLandscapePageData || this.pageDimensions[0] || this.viewport_size;
			const displayPageCount = this.hasLandscapePage ? 1 : 2;
			const availableWidth = Math.max(window.innerWidth - 30, 320);
			const availableHeight = Math.max(window.innerHeight * 0.85, 260);
			const scale = Math.min(availableWidth / (basePage.width * displayPageCount), availableHeight / basePage.height);
			const pageWidth = Math.max(Math.round(basePage.width * scale), 1);
			const pageHeight = Math.max(Math.round(basePage.height * scale), 1);

			return {
				pageWidth,
				pageHeight,
				bookWidth: pageWidth * displayPageCount,
			};
		},

		applyBookFitSize() {
			// 设置书本尺寸，保持 PDF 的原始比例
			const bookFitSize = this.getBookFitSize();
			this.pageFlipBoxWidth = bookFitSize.pageWidth;
			this.pageFlipBoxHeight = bookFitSize.pageHeight;

			const pageBoxEl = document.getElementsByClassName('page-box')[0];
			if (pageBoxEl) {
				pageBoxEl.style.width = this.is_mobile ? '100%' : `${bookFitSize.bookWidth + 30}px`;
			}
		},

		initBookLayout() {
			this.applyBookFitSize();

			this.loadBook();
			this.is_show_btn = true;
			this.fullscreenLoading = false;

			if (this.filePage == 1 && !this.is_mobile) {
				const flipBook = document.getElementsByClassName('flip-book')[0];
				flipBook.style.backgroundColor = 'transparent';
				flipBook.style.boxShadow = 'none';
				flipBook.style.marginLeft = `${flipBook.getBoundingClientRect().width / 4}px`;
			}
		},

		loadBook() {
			this.pageFlipObj = new PageFlip(document.getElementById('demoBookExample'), {
				width: this.pageFlipBoxWidth,
				height: this.pageFlipBoxHeight,
				size: 'fixed', // "fixed" or "stretch"
				// minWidth: this.pageFlipBoxWidth,
				// maxWidth: this.pageFlipBoxWidth,
				// minHeight: this.pageFlipBoxHeight,
				// maxHeight: this.pageFlipBoxHeight,
				flippingTime: 600,
				maxShadowOpacity: 0.3, // 稍微调淡阴影更清晰
				mobileScrollSupport: false,
				usePortrait: this.hasLandscapePage, // 有横版页面时使用单页显示，否则保持双页显示
			});
			this.pageFlipObj.loadFromHTML(document.querySelectorAll('.page'));
			this.pageTotal = this.pageFlipObj.getPageCount();
			this.pageFlipObj.on('flip', (e) => {
				if (this.hasLandscapePage) {
					this.current = e.data + 1;
				} else {
					this.current = e.data + 2;
				}
			});
		},

		// 下载相关辅助函数
		dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		},
		handleDown(row) {
			const _that = this;
			this.getBlob(row.url, function (blob) {
				_that.saveAs(blob, row.fileName);
			});
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.responseType = 'blob';
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response);
				}
			};
			xhr.send();
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename);
			} else {
				var link = document.createElement('a');
				var body = document.querySelector('body');
				link.href = window.URL.createObjectURL(blob);
				link.download = filename;
				link.style.display = 'none';
				body.appendChild(link);
				link.click();
				body.removeChild(link);
				window.URL.revokeObjectURL(link.href);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.permission_dialog_box {
	width: 100%;
	text-align: center;

	.info_img {
		width: 38px;
		height: 38px;
		margin: 20px;
	}

	.permission_p {
		font-size: 15px;
		font-weight: 400;
		color: #303133;
	}

	.permission_div1 {
		margin: 20px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 16px;
			height: 16px;
			margin: 0 10px;
		}

		span {
			font-size: 14px;
			font-weight: 400;
			color: #2d91e3;
		}
	}

	.permission_div2 {
		margin-top: 30px;
	}
}

.flip_box {
	min-width: 1440px;
	display: flex;
	min-height: 100vh;
	overflow: hidden;
}

.bj_img {
	position: fixed;
	z-index: -10;
	width: 100%;
	height: 100%;
	min-width: 1440px;
}

.page-box {
	// max-width: 1440px;
	// max-height: 950px;
	width: 100%;
	margin: auto;
	padding: 0 15px;
	transform: translateY(15px);
	// padding-top: 70px;
	// background-image: linear-gradient(to right, #c59280, #724a47);
	// overflow: hidden;

	.btn-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: relative;

		.info-box {
			.p1,
			.p2 {
				color: white;
				font-size: 12px;
				text-shadow: 0px 0px 10px rgb(0, 0, 0);
				margin-right: 20px;
			}
		}

		.button-box {
			margin: 20px auto;
			width: 20px;
			flex-grow: 1;
			display: flex;
			// flex-direction: column;
			justify-content: center;
			align-items: center;

			> div {
				margin: 10px;
				display: flex;
				background: rgba(48, 49, 51, 0.4);
				border-radius: 24px;
				font-size: 13px;
				font-weight: 400;
				color: #ffffff;
				padding: 5px 20px;

				> span {
					cursor: pointer;
				}
			}
		}
	}

	.flip-book {
		box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
		display: none;
		background-size: cover;
		background: #ffffff;
	}

	.page {
		background-color: hsl(35, 55, 98);
		color: hsl(35, 35, 35);
		border: solid 1px hsl(35, 20, 70);
		overflow: hidden;
		.canvas-loading {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			font-size: 12px;
			@keyframes spin {
				from {
					transform: rotate(0deg);
				}
				to {
					transform: rotate(360deg);
				}
			}
			.loading-icon {
				display: inline-block;
				animation: spin 2s linear infinite;
			}
		}
		.page-footer {
			height: 30px;
			// border-top: solid 1px hsl(35, 55, 90);
			font-size: 80%;
			color: hsl(35, 20, 50);
			position: absolute;
			width: 90%;
			bottom: 0;
		}

		&.--left {
			// for left page (property will be added automatically)
			border-right: 0;
			box-shadow: inset -7px 0 30px -7px rgba(0, 0, 0, 0.4);
		}

		&.--right {
			// for right page (property will be added automatically)
			border-left: 0;
			box-shadow: inset 7px 0 30px -7px rgba(0, 0, 0, 0.4);

			.page-footer {
				text-align: right;
			}
		}

		&.hard {
			// for hard page
			background-color: hsl(35, 50, 90);
			border: solid 1px hsl(35, 20, 50);
		}

		&.page-cover {
			background-color: rgb(233, 190, 130);
			color: hsl(35, 35, 35);
			border: solid 1px hsl(35, 20, 50);

			h2 {
				text-align: center;
				padding-top: 50%;
				font-size: 210%;
			}

			&.page-cover-top {
				box-shadow: inset 0px 0 30px 0px rgba(36, 10, 3, 0.5), -2px 0 5px 2px rgba(0, 0, 0, 0.4);
			}

			&.page-cover-bottom {
				box-shadow: inset 0px 0 30px 0px rgba(36, 10, 3, 0.5), 10px 0 8px 0px rgba(0, 0, 0, 0.4);
			}
		}
	}
}

@media screen and (max-width: 500px) {
	.flip_box {
		min-width: 100vw;
		width: 100vw;
	}

	.page-box {
		width: 100vw !important;

		.button-box {
			width: 100%;
			display: flex;

			> div {
				display: flex;

				> span {
					white-space: nowrap;
				}

				> div {
					display: flex;
					align-items: center;

					> span {
						white-space: nowrap;
					}
				}
			}
		}
	}
}
</style>
<style>
.dialog_class {
	width: 80% !important;
	max-width: 500px !important;
}
.page-content {
	/* background-color: #fff; */
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden; /* 必须加，防止高分 Canvas 溢出 */
	display: flex;
	align-items: center;
	justify-content: center;
}

.flip-book {
	will-change: transform;
	transform: translateZ(0);
	backface-visibility: hidden;
	perspective: 1000;
	/* 建议增加以下两行，提升翻页时的平滑度 */
	touch-action: none;
	user-select: none;
}

/* 优化 Canvas 渲染性能 */
canvas {
	/* 解决部分浏览器渲染文字发虚 */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
